<template>
  <a v-if="url" class="button-secondary-icon" :href="url" target="_blank" @click="pushEvent">
    <SquareIcon class="button-secondary-icon__icon" :icon="icon" />
    {{ label }}
  </a>

  <router-link v-else class="button-secondary-icon" :to="{name: 'page', params: {page: internalUrlParam || 'home'}}">
    <SquareIcon class="button-secondary-icon__icon" :icon="icon" />
    {{ label }}
  </router-link>
</template>

<script setup>
import { pushData } from "@/utilities/analytics-functions.js";

import SquareIcon from "./SquareIcon.vue";

const props = defineProps({
  url: String,
  internalUrlParam: Object,
  label: String,
  icon: Object,
});

function pushEvent() {
  if (props.url && props.url.includes('.pdf')) {
      pushData('pdf', props.url, '', props.label)
  }
}
</script>

<style lang="scss" scoped>
.button-secondary-icon {
  @include link-m;

  color: var(--primary-yellow);
  display: flex;
  align-items: center;
  gap: 0.8rem;

  &__icon {
    background-color: var(--primary-yellow);
    border-radius: 2px;
    width: 1.5rem;
    aspect-ratio: 1;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    color: var(--primary-yellow-light);

    .button-secondary-icon__icon {
      background-color: var(--primary-yellow-light);
    }
  }
}
</style>
